import React, { useEffect, useState } from 'react';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';
import { bindActionCreators } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import {  setFTEligible } from './store/actions/productAction';
import UbisoftPLusLoader from './components/UbisoftPlusLoader/UbisoftPlusLoader';
import Hero from './components/Hero/Hero';
import Description from './components/Description/Description';
import Advantages from './components/Advantages/Advantages';
import FAQ from './components/FAQ/FAQ';
import { AppActions } from './types/store/action';
import '../node_modules/slick-carousel/slick/slick.scss';
import '../node_modules/slick-carousel/slick/slick-theme.css';
import { setUpWaData } from './utils';
import BannerList from './components/Banners/BannerList';
import Legal from './components/Legal/Legal';
import { Konami } from './components/Konami/Konami';
import UbisoftPlusNavigation from './components/UbisoftPlusNavigation/UbisoftPlusNavigation';
import { StyleSheetManager } from 'styled-components';
import PriceBannerBlock from './components/PriceBannerBlock/PriceBannerBlock';
import Banner from './components/Banners/Banner';
import './components/Banners/Banners.scss';
import Gamelist from './components/GameList/Gamelist';
import HeroCloud from './components/UI/HeroCloud/HeroCloud';
import CONFIG from './config';
import { fetchWindowVariables } from './store/actions/appAction';
import { IState } from './types/store/reducer';

if (process.env.REACT_APP_ENV === 'upc') {
  require('./styles/uplayFonts.scss');
} else {
  require('./styles/storeFonts.scss');
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AppActions>) => ({
  setFTEligible: bindActionCreators(setFTEligible, dispatch),
  fetchWindowVariables: bindActionCreators(fetchWindowVariables, dispatch)
});

const mapStateToProps = (state: IState) => ({
  app: state.app,
  products :state.products
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = (props: AppProps) => {
  const { localeId, setFTEligible, app, products, fetchWindowVariables } = props;
  const localizedContent: IContent = data.filter(
    locale => locale.lang === localeId
  )[0];

  const [konamiState, setKonamiState] = useState(false);
  let konami = new Konami();
  useEffect(() => {
    document.addEventListener('keydown', event => {
      if (konami.dispatchKeyKode(event.keyCode.toString())) {
        setKonamiState(konamiState => true);
        konami.animate();
      }
    });
    fetchWindowVariables();
    setFTEligible();
    setUpWaData();
  }, []);

  return (
    <main className="uplayplus">
      <ContentProvider value={localizedContent}>
        <StyleSheetManager
          target={document.querySelector('#stylesheetsContainer')}
          disableCSSOMInjection={true}
        >
          <>
            {/*Removed navigation bar for upc*/}
            {!CONFIG.isUPC && <UbisoftPlusNavigation />}

            {konamiState && konami.renderRainfall()}
            <Hero
              freeTrialEligible={products.uplayData.ftEligible}
            />

            {!app.windowVariablesInitialised && (
              <UbisoftPLusLoader />
            )}

            <Description />
            <Gamelist />
            <BannerList />
            <Advantages
              freeTrialEligible={products.uplayData.ftEligible}
            />
            <div
              className={'banners_component_container ubisoft-connect-banner'}
            >
              <Banner
                bannerItem={localizedContent.ubisoftConnectBanner}
                ctas={localizedContent.cta}
                cloudBanner={false}
              />
            </div>
            <PriceBannerBlock />
            <FAQ />
            <Legal />
          </>
        </StyleSheetManager>
      </ContentProvider>
    </main>
  );
};

export default connector(App);